import CustomNode from "./CustomNode";
import { moduleRunStatusData, transformApiDataToModuleStatus } from "./moduleRunStatusData";

export const getNodesData = (apiData) => {
  const nodesData = transformApiDataToModuleStatus(apiData);

const nodes = [
    {
      id: 'fgs',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.fgs}/> },
      position: { x: 0, y: 140 },
    },
    {
      id: 'dom',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.dom}/> },
      position: { x: 400, y: 0 },
    },
    {
      id: 'do',
      type: 'multiTarget',
      data: { label: <CustomNode details={nodesData.moduleDetails.do}/> },
      position: { x: 400, y: 300 },
    },
    {
      id: 'rdp',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.rdp}/> },
      position: { x: 800, y: 65 },
    },
    {
      id: 'cp',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.cp}/> },
      position: { x: 1200, y: 50 },
    },
    {
      id: 'ff',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.ff}/> },
      position: { x: 1200, y: 300 },
    },
    {
      id: 'poos',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.poos}/> },
      position: { x: 0, y: 400 },
    },
    {
      id: 'slp',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.slp}/> },
      position: { x: 400, y: 600 },
    },
    {
      id: 'iof',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.iof}/> },
      position: { x: 800, y: 350 },
    },
    {
      id: 'rr',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.rr}/> },
      position: { x: 0, y: 660 },
    },
    {
      id: 'nps',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.nps}/> },
      position: { x: 1200, y: 600 },
    },
    {
      id: 'erm',
      type: "singleTarget",
      data: { label: <CustomNode details={nodesData.moduleDetails.erm}/> },
      position: { x: 800, y: 600 },
    },
  ];
  return nodes;
};
export const nodes = [
    {
      id: 'fgs',
      type: "singleTarget",
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.fgs}/> },
      position: { x: 0, y: 300 },
    },
    {
      id: 'dom',
      type: "singleTarget",
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.dom}/> },
      position: { x: 400, y: 100 },
    },
    {
      id: 'do',
      type: 'multiTarget',
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.do}/> },
      position: { x: 400, y: 500 },
    },
    {
      id: 'rdp',
      type: "singleTarget",
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.rdp}/> },
      position: { x: 800, y: 300 },
    },
    {
      id: 'cp',
      type: "singleTarget",
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.cp}/> },
      position: { x: 1200, y: 100 },
    },
    {
      id: 'ff',
      type: "singleTarget",
      data: { label: <CustomNode details={moduleRunStatusData.moduleDetails.ff}/> },
      position: { x: 1200, y: 500 },
    },
  ];